import type { PackName } from '../../pages/browser-plugins/chromium/constants';

// Define the message type expected by Recruitee
const RECRUITEE_IFRAME_MESSAGE_TYPE = "EmbedMessage";
// Fallback for existing integrations
const HIREPORT_IFRAME_MESSAGE_TYPE = "HirePortIFrameMessage";

// !TODO: review this - the targetOrigin parameter specifies which domains are allowed to receive messages from this page
// when it's rendered in an iframe. This is essentially the list of ATSes (and their sandbox alternatives)
// which are supported. For now I'm setting to allow posting messages to any origin, but this is not maximally
// secure. Ideally, get the target origin from Recruitee if possible or configure per integration.
const TARGET_ORIGIN = "*";

// Define ATS configurations mapping
type AtsConfig = {
  messageType?: string;
  transform?: (payload: any) => any;
}

const defaultConfig: AtsConfig = {
  messageType: HIREPORT_IFRAME_MESSAGE_TYPE,
  transform: payload => ({ payload }),
};

const atsConfigs: Record<PackName | 'plugin', AtsConfig> = {
  recruitee: {
    messageType: RECRUITEE_IFRAME_MESSAGE_TYPE,
    transform: localPayload => ({ payload: localPayload }),
  },
  jobylon: {
    transform: localPayload => ({
      partner: "HirePort",
      api: "Embedding",
      payload: {
        error: localPayload.event === 'AuthenticationError' ? 'authentication_error' :
          localPayload.event === 'UIInterfaceError' ? localPayload.error || 'interface_error' :
            localPayload.event === 'UIActionComplete' ? 'action_complete' :
              'unknown_error'
      }
    }),
  },
  smartrecruiters: {
    ...defaultConfig,
  },
  plugin: {
    ...defaultConfig,
  }
};

export const postMessage = (
  payload: { event: string;[key: string]: any },
  strategy: PackName | 'plugin',
) => {
  const config = atsConfigs[strategy];
  const messagePayload = config.transform ? config.transform(payload) : payload;
  const finalMessageObject = config.messageType ?
    { type: config.messageType, ...messagePayload } :
    messagePayload;

  if (strategy === 'recruitee') {
    console.log('[browserPlugins] Attempting to postMessage to Recruitee (parent). Exact object being sent:', finalMessageObject);
  }

  if (strategy === 'jobylon') {
    console.log('[browserPlugins] Attempting to postMessage to Jobylon (parent). Exact object being sent:', finalMessageObject);
  }

  window.parent.postMessage(finalMessageObject, TARGET_ORIGIN);
};
